const MAX_PARSE_CHARS = 2000

const BULLET_PREFIX = /^[\s]*(?:[•‣▸◦▪\-*–—])\s+/
const NUMBERED_PREFIX = /^[\s]*\d+[\.\)]\s+/
const TIMELINE_PATTERNS = [
  /^(\d{4}-\d{2}-\d{2})\s+(.+)$/,
  /^(\d{4}-\d{2})\s+(.+)$/,
  /^(Q[1-4]\s+\d{4})\s+(.+)$/i,
  /^((?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s+\d{4})\s+(.+)$/i,
  /^((?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s+\d{1,2},?\s+\d{4})\s+(.+)$/i,
]

function normalizeRaw(text) {
  return String(text ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
}

function nonEmptyLines(text) {
  return normalizeRaw(text)
    .split('\n')
    .map((line) => line.replace(/\t/g, ' ').trim())
    .filter((line) => line.length > 0)
}

function stripBullet(line) {
  return line.replace(BULLET_PREFIX, '').trim()
}

function stripNumbered(line) {
  return line.replace(NUMBERED_PREFIX, '').trim()
}

function isNumberedLine(line) {
  return NUMBERED_PREFIX.test(line)
}

function isBulletLine(line) {
  return BULLET_PREFIX.test(line)
}

function parseTimelineLine(line) {
  for (const pattern of TIMELINE_PATTERNS) {
    const match = line.match(pattern)
    if (match) {
      return { date: match[1].trim(), text: match[2].trim() }
    }
  }
  return null
}

/**
 * @param {string} text
 * @returns {{ type: string, items: Array<string|{date:string,text:string}>, truncated?: boolean }}
 */
export function parseClipboardText(text) {
  const raw = normalizeRaw(text)
  const truncated = raw.length > MAX_PARSE_CHARS
  const bounded = truncated ? raw.slice(0, MAX_PARSE_CHARS) : raw
  const lines = nonEmptyLines(bounded)

  if (!lines.length) {
    return { type: 'plain', items: [''] }
  }

  if (lines.length > 0 && lines.every(isNumberedLine)) {
    return {
      type: 'numbered',
      items: lines.map(stripNumbered),
      ...(truncated ? { truncated: true } : {}),
    }
  }

  if (lines.length > 0 && lines.every(isBulletLine)) {
    return {
      type: 'bullet',
      items: lines.map(stripBullet),
      ...(truncated ? { truncated: true } : {}),
    }
  }

  const timelineItems = lines
    .map(parseTimelineLine)
    .filter(Boolean)

  if (timelineItems.length === lines.length && timelineItems.length > 0) {
    return {
      type: 'timeline',
      items: timelineItems,
      ...(truncated ? { truncated: true } : {}),
    }
  }

  if (lines.length > 3) {
    return {
      type: 'multiline',
      items: lines,
      ...(truncated ? { truncated: true } : {}),
    }
  }

  return {
    type: 'plain',
    items: [bounded.trim()],
    ...(truncated ? { truncated: true } : {}),
  }
}
